export const addAllToRecord: <T>(record: Record<string, T>, newValues?: Record<string, T>) => Record<string, T> = (
  record,
  newValues = {}
) => ({
  ...record,
  ...newValues,
});
